import React from 'react';
import Icon from '../../RushShell/icons';
import Sparkline from './Sparkline';

const MetricCard = ({ icon, iconClass, label, value, unit, delta, deltaDir, spark, sparkColor }) => (
    <div className="rs-metric">
        <div className="lbl">
            <span className={`ic ${iconClass || ''}`}>{icon}</span>
            <span>{label}</span>
        </div>
        <div className="val">
            {value}
            {unit && <span className="unit">{unit}</span>}
        </div>
        {delta && (
            <div className={`delta ${deltaDir}`}>
                {deltaDir === 'up' ? '↑' : '↓'} {delta}
                <span className="since">vs last week</span>
            </div>
        )}
        {spark && spark.length > 0 && <Sparkline data={spark} color={sparkColor} />}
    </div>
);

const Metrics = ({ data }) => {
    const d = data || {};
    const activeProjects = d.activeProjects || {};
    const words = d.wordsThisMonth || {};
    const turnaround = d.avgTurnaround || {};
    const quality = d.qualityScore || {};
    return (
        <div className="rs-metrics">
            <MetricCard
                icon={Icon.folder}
                label="Active projects"
                value={activeProjects.value ?? '—'}
                delta={activeProjects.delta}
                deltaDir={activeProjects.deltaDir}
                spark={activeProjects.spark}
                sparkColor="var(--accent)"
            />
            <MetricCard
                icon={Icon.globe}
                iconClass="indigo"
                label="Words this month"
                value={words.value ?? '—'}
                delta={words.delta}
                deltaDir={words.deltaDir}
                spark={words.spark}
                sparkColor="var(--indigo)"
            />
            <MetricCard
                icon={Icon.clock}
                iconClass="green"
                label="Avg turnaround"
                value={turnaround.value ?? '—'}
                unit={turnaround.unit || 'days'}
                delta={turnaround.delta}
                deltaDir={turnaround.deltaDir}
                spark={turnaround.spark}
                sparkColor="var(--green)"
            />
            <MetricCard
                icon={Icon.star}
                iconClass="yellow"
                label="Quality score"
                value={quality.value ?? '—'}
                unit={quality.unit || '%'}
                delta={quality.delta}
                deltaDir={quality.deltaDir}
                spark={quality.spark}
                sparkColor="#a87a14"
            />
        </div>
    );
};

export default Metrics;
